exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-stepper[data-v-b6550a90]{border:0!important;-webkit-box-shadow:none!important;box-shadow:none!important}.v-stepper[data-v-b6550a90],.v-stepper__content[data-v-b6550a90]{padding:0!important}", ""]);

// exports
